/**
 * Dates and times from the API (ftdb.sqlite3 stores them as text):
 *   'YYYY-MM-DD HH:MM:SS' -- an instant, in UTC (created/modified/completed,
 *                            deadlines). `new Date()` would read it as local
 *                            time, so parse it with parseDbDate.
 *   'YYYY-MM-DD'          -- a calendar date (job date, last engagement).
 * Session start/end are the exception: the same shape as an instant, but the
 * local time the session runs at -- don't pass those to parseDbDate.
 */

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DB_DATETIME_RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

/**
 * A Date for a value from the API, or null if there's none / it doesn't parse.
 * 'YYYY-MM-DD HH:MM:SS' is UTC; 'YYYY-MM-DD' is that day at local midnight;
 * anything else (ISO strings with 'T'/'Z', Date objects) goes to `new Date()`.
 */
export function parseDbDate(value) {
  if (value === null || value === undefined || value === '') return null;
  let d;
  if (value instanceof Date) {
    d = value;
  } else {
    const s = String(value).trim();
    const dateOnly = DATE_ONLY_RE.exec(s);
    if (dateOnly) {
      d = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
    } else if (DB_DATETIME_RE.test(s)) {
      d = new Date(`${s.replace(' ', 'T')}Z`);
    } else {
      d = new Date(s);
    }
  }
  return Number.isNaN(d.getTime()) ? null : d;
}
